import React from 'react';
import PropTypes from 'prop-types';
import { ModalWrapper, Content, ContentTheme } from './doughnut-tooltip.styled';

export const ContextModalWidth = 203;

const ContextModal = (props) => {
  let bgColor = 'white';
  let hoverTextColor;
  if (props.contextTheme === 'standard') {
    bgColor = '#3B4E5E';
    hoverTextColor = 'white';
  } else if (props.contextTheme === 'learningJourney') {
    bgColor = '#4F5C67';
  }
  const modalWidth = !props.unrestrictedWidth && ContextModalWidth;
  return (
    props.show && (
      <ModalWrapper
        positionArrow={props.positionArrow}
        positionArrowFixed={props.positionArrowFixed}
        positionX={props.positionX}
        positionY={props.positionY}
        modalWidth={props.modalWidth ? props.modalWidth : modalWidth}
        bgColor={bgColor}
        hoverTextColor={hoverTextColor}
        customStyle={props.customStyle}
        fixedParent={props.fixedParent}
        contextPos={props.contextPos}
      >
        {props.contextTheme ? (
          <ContentTheme data-testid="name">{props.name}</ContentTheme>
        ) : (
          <Content data-testid="content">{props.children}</Content>
        )}
      </ModalWrapper>
    )
  );
};

ContextModal.propTypes = {
  children: PropTypes.any,
  show: PropTypes.bool,
  positionX: PropTypes.number,
  positionY: PropTypes.number,
  positionArrow: PropTypes.number,
  positionArrowFixed: PropTypes.number,
  contextTheme: PropTypes.string,
  name: PropTypes.any,
  customStyle: PropTypes.string,
  contextPos: PropTypes.string,
  unrestrictedWidth: PropTypes.bool,
  fixedParent: PropTypes.bool,
  modalWidth: PropTypes.number
};

export default ContextModal;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/doughnut-chart/doughnut-tooltip/doughnut-tooltip.js